/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React, { useState } from 'react';
import { isMobileView } from '../../../utilities';
import { DetailedDeliveryInformationProps } from '../lxs-anonymous-delivery.data';
import DeliveryEventList from './delivery-event-list';

const DetailedDeliveryInformation: React.FC<DetailedDeliveryInformationProps> = ({
    CLASS_NAME,
    events,
    resources,
    localizationState,
    context
}) => {
    const [showDetails, setShowDetails] = useState<boolean>(false);
    const isMobile: boolean = isMobileView(context);

    return (
        <div className={`${CLASS_NAME}__detailed-information`}>
            <div className={`${CLASS_NAME}__detailed-information-details-column`}>
                {isMobile ? (
                    <h4
                        className={`${CLASS_NAME}__toggle ${showDetails ? `${CLASS_NAME}__toggle--open` : ''}`}
                        onClick={() => setShowDetails(!showDetails)}
                    >
                        {showDetails ? resources.lxsAnonymousDeliveryHideDetailsToggle : resources.lxsAnonymousDeliveryShowDetailsToggle}
                    </h4>
                ) : (
                    <h4 className={`${CLASS_NAME}__title`}>{resources.lxsAnonymousDeliveryDetailsTitle}</h4>
                )}
                <div className={!isMobile || showDetails ? `${CLASS_NAME}__event-list-wrapper--open` : `${CLASS_NAME}__event-list-wrapper`}>
                    <DeliveryEventList
                        CLASS_NAME={CLASS_NAME}
                        events={events}
                        resources={resources}
                        localizationState={localizationState}
                    />
                </div>
            </div>
        </div>
    );
};

export default DetailedDeliveryInformation;
